import { frontendURL } from '../../../../helper/URLHelper';
import {
  ROLES,
  AVAILABLE_CUSTOM_ROLE_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import SettingsContent from './Wrapper.vue';
import Index from './Index.vue';

// Rota de aterrissagem de último recurso: o perfil não depende de nenhuma
// permissão de negócio, então TEM que ser alcançável por qualquer custom role.
// 'custom_role' sozinho não servia — account_user#permissions devolve a lista
// de permissões da role, nunca a string 'custom_role', então nenhum agente com
// role personalizada passava por aqui.
const PROFILE_PERMISSIONS = [...ROLES, ...AVAILABLE_CUSTOM_ROLE_PERMISSIONS];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/profile'),
      name: 'profile_settings',
      meta: {
        permissions: PROFILE_PERMISSIONS,
      },
      component: SettingsContent,
      children: [
        {
          path: 'settings',
          name: 'profile_settings_index',
          component: Index,
          meta: {
            permissions: PROFILE_PERMISSIONS,
          },
        },
      ],
    },
  ],
};
